<template>
  <materials-list />
</template>

<script>
import { mapGetters } from 'vuex';
import HeadMixin from '~/mixins/HeadMixin';
import MaterialsList from '~/pages/articles/index.vue';
import { getCategoryShareImage } from '~/components/materials/utils';

export default {
  name: 'NewsListPage',
  components: { MaterialsList },
  mixins: [HeadMixin],
  layout: 'DefaultLayoutV2',
  /**
   * Это динамическая страница.
   * По сути можно ввести любой адрес несуществующей страницы и попасть сюда
   * И если не соответствует эта страница существующей категории, переводим на 404
   */
  async asyncData(ctx) {
    const categories = await ctx.$api.getPublicMaterialCategories() || [];
    const validCategories = [];
    categories.forEach((base) => {
      validCategories.push(base.slug);

      if (Array.isArray(base.children) && base.children.length) {
        base.children.forEach((children) => validCategories.push(children.slug));
      }
    });

    const category = ctx.route?.params?.material_category;
    if (!validCategories.includes(category)) {
      ctx.error({ statusCode: 404, message: 'Страница не найдена' });
    }
  },
  data: () => ({
    canonical: true,
  }),
  computed: {
    ...mapGetters({
      categories: 'getMaterialCategories',
    }),
    currentCategory() {
      const pageCategory = this.$route.params.material_category;
      return this.categories.find(({ slug }) => pageCategory === slug) || {};
    },
    title() {
      // eslint-disable-next-line
      return this.currentCategory?.title || 'Медиа для родителей и детей: образование, школа, ЕГЭ, ОГЭ, профессии, психология';
    },
    description() {
      // eslint-disable-next-line
      return this.currentCategory?.description || 'В нашем блоге найдете актуальные новости, советы по домашнему обучению, статьи о психологии ребенка, лайфхаки для успешной учебы, информацию о профессиях, а также полезные советы для родителей';
    },
    image() {
      return getCategoryShareImage(this.selectedCategory);
    },
  },
};
</script>
